// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
   1. DASHBOARD GLOBAL STYLES (CRM SECTION)
   ========================================================================== */

html {
    box-sizing: border-box;
}

*, *:before, *:after {
    box-sizing: inherit;
}

.dashboard-container {
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
    color: #1e293b;
    line-height: 1.6; /* Better readability */
    font-size: 16px; /* Base font size increased */
}

/* Modern Data Tables */
.dashboard-container table {
    width: 100% !important;
    border-collapse: separate !important;
    border-spacing: 0 !important;
    margin: 24px 0 !important;
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.dashboard-container th {
    background: #f8fafc !important;
    color: #64748b !important;
    font-weight: 700 !important;
    font-size: 14px; /* Increased from 11px/13px */
    letter-spacing: 0.01em;
    padding: 16px 20px !important;
    border-bottom: 2px solid #e2e8f0 !important;
    white-space: nowrap;
    text-align: left;
}

.dashboard-container td {
    padding: 18px 20px !important; /* More breathing room */
    border-bottom: 1px solid #f1f5f9 !important;
    font-size: 15px; /* Increased from 14px */
    background: #fff;
    color: #334155;
}

.dashboard-container tr:hover td {
    background-color: #f8fafc;
}

/* Form Elements (Inputs, Textareas, Labels) */
.dashboard-container label {
    display: block;
    margin-bottom: 8px;
    font-size: 14px; /* Increased */
    font-weight: 600;
    color: #475569;
}

.dashboard-container input,
.dashboard-container textarea {
    display: block;
    width: 100%;
    box-sizing: border-box;
    padding: 14px 18px !important; /* Larger touch targets */
    font-size: 16px !important; /* Prevents auto-zoom on iOS and improves readability */
    color: #1e293b;
    background-color: #ffffff;
    border: 1px solid #cbd5e1 !important;
    border-radius: 10px !important;
    transition: all 0.2s ease-in-out;
}

.dashboard-container input:focus,
.dashboard-container textarea:focus {
    border-color: #5ca9fb !important;
    box-shadow: 0 0 0 4px rgba(92, 169, 251, 0.15) !important;
    outline: none;
}

/* Sidebar Menu Alignment Fix */
.dashboard-container aside div {
    display: flex;
    align-items: center; /* Aligns icon and text perfectly */
    gap: 12px;
    font-size: 16px;
    font-weight: 500;
}

/* Dashboard Action Buttons */
.dashboard-container .btn-primary {
    background-color: #5ca9fb !important;
    color: #fff !important;
    border: none !important;
    padding: 14px 32px !important;
    border-radius: 50px !important;
    font-weight: 600 !important;
    font-size: 15px;
    cursor: pointer;
    box-shadow: 0 4px 6px -1px rgba(92, 169, 251, 0.3);
}

/* ==========================================================================
   2. RESPONSIVE MEDIA QUERIES
   ========================================================================== */

@media screen and (max-width: 768px) {
    .dashboard-container table {
        display: block;
        width: 100%;
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
    }

    .dashboard-container td, 
    .dashboard-container th {
        padding: 12px 15px !important;
        font-size: 14px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;;+EAE+E;;AAE/E;IACI,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,uFAAuF;IACvF,cAAc;IACd,gBAAgB,EAAE,uBAAuB;IACzC,eAAe,EAAE,6BAA6B;AAClD;;AAEA,uBAAuB;AACvB;IACI,sBAAsB;IACtB,oCAAoC;IACpC,4BAA4B;IAC5B,yBAAyB;IACzB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,yCAAyC;AAC7C;;AAEA;IACI,8BAA8B;IAC9B,yBAAyB;IACzB,2BAA2B;IAC3B,eAAe,EAAE,6BAA6B;IAC9C,sBAAsB;IACtB,6BAA6B;IAC7B,2CAA2C;IAC3C,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,6BAA6B,EAAE,wBAAwB;IACvD,2CAA2C;IAC3C,eAAe,EAAE,wBAAwB;IACzC,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,8CAA8C;AAC9C;IACI,cAAc;IACd,kBAAkB;IAClB,eAAe,EAAE,cAAc;IAC/B,gBAAgB;IAChB,cAAc;AAClB;;AAEA;;IAEI,cAAc;IACd,WAAW;IACX,sBAAsB;IACtB,6BAA6B,EAAE,yBAAyB;IACxD,0BAA0B,EAAE,uDAAuD;IACnF,cAAc;IACd,yBAAyB;IACzB,oCAAoC;IACpC,8BAA8B;IAC9B,gCAAgC;AACpC;;AAEA;;IAEI,gCAAgC;IAChC,yDAAyD;IACzD,aAAa;AACjB;;AAEA,+BAA+B;AAC/B;IACI,aAAa;IACb,mBAAmB,EAAE,mCAAmC;IACxD,SAAS;IACT,eAAe;IACf,gBAAgB;AACpB;;AAEA,6BAA6B;AAC7B;IACI,oCAAoC;IACpC,sBAAsB;IACtB,uBAAuB;IACvB,6BAA6B;IAC7B,8BAA8B;IAC9B,2BAA2B;IAC3B,eAAe;IACf,eAAe;IACf,kDAAkD;AACtD;;AAEA;;+EAE+E;;AAE/E;IACI;QACI,cAAc;QACd,WAAW;QACX,gBAAgB;QAChB,iCAAiC;IACrC;;IAEA;;QAEI,6BAA6B;QAC7B,eAAe;IACnB;AACJ","sourcesContent":["/* ==========================================================================\n   1. DASHBOARD GLOBAL STYLES (CRM SECTION)\n   ========================================================================== */\n\nhtml {\n    box-sizing: border-box;\n}\n\n*, *:before, *:after {\n    box-sizing: inherit;\n}\n\n.dashboard-container {\n    font-family: 'Inter', -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif;\n    color: #1e293b;\n    line-height: 1.6; /* Better readability */\n    font-size: 16px; /* Base font size increased */\n}\n\n/* Modern Data Tables */\n.dashboard-container table {\n    width: 100% !important;\n    border-collapse: separate !important;\n    border-spacing: 0 !important;\n    margin: 24px 0 !important;\n    background: #ffffff;\n    border: 1px solid #e2e8f0;\n    border-radius: 12px;\n    overflow: hidden;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n}\n\n.dashboard-container th {\n    background: #f8fafc !important;\n    color: #64748b !important;\n    font-weight: 700 !important;\n    font-size: 14px; /* Increased from 11px/13px */\n    letter-spacing: 0.01em;\n    padding: 16px 20px !important;\n    border-bottom: 2px solid #e2e8f0 !important;\n    white-space: nowrap;\n    text-align: left;\n}\n\n.dashboard-container td {\n    padding: 18px 20px !important; /* More breathing room */\n    border-bottom: 1px solid #f1f5f9 !important;\n    font-size: 15px; /* Increased from 14px */\n    background: #fff;\n    color: #334155;\n}\n\n.dashboard-container tr:hover td {\n    background-color: #f8fafc;\n}\n\n/* Form Elements (Inputs, Textareas, Labels) */\n.dashboard-container label {\n    display: block;\n    margin-bottom: 8px;\n    font-size: 14px; /* Increased */\n    font-weight: 600;\n    color: #475569;\n}\n\n.dashboard-container input,\n.dashboard-container textarea {\n    display: block;\n    width: 100%;\n    box-sizing: border-box;\n    padding: 14px 18px !important; /* Larger touch targets */\n    font-size: 16px !important; /* Prevents auto-zoom on iOS and improves readability */\n    color: #1e293b;\n    background-color: #ffffff;\n    border: 1px solid #cbd5e1 !important;\n    border-radius: 10px !important;\n    transition: all 0.2s ease-in-out;\n}\n\n.dashboard-container input:focus,\n.dashboard-container textarea:focus {\n    border-color: #5ca9fb !important;\n    box-shadow: 0 0 0 4px rgba(92, 169, 251, 0.15) !important;\n    outline: none;\n}\n\n/* Sidebar Menu Alignment Fix */\n.dashboard-container aside div {\n    display: flex;\n    align-items: center; /* Aligns icon and text perfectly */\n    gap: 12px;\n    font-size: 16px;\n    font-weight: 500;\n}\n\n/* Dashboard Action Buttons */\n.dashboard-container .btn-primary {\n    background-color: #5ca9fb !important;\n    color: #fff !important;\n    border: none !important;\n    padding: 14px 32px !important;\n    border-radius: 50px !important;\n    font-weight: 600 !important;\n    font-size: 15px;\n    cursor: pointer;\n    box-shadow: 0 4px 6px -1px rgba(92, 169, 251, 0.3);\n}\n\n/* ==========================================================================\n   2. RESPONSIVE MEDIA QUERIES\n   ========================================================================== */\n\n@media screen and (max-width: 768px) {\n    .dashboard-container table {\n        display: block;\n        width: 100%;\n        overflow-x: auto;\n        -webkit-overflow-scrolling: touch;\n    }\n\n    .dashboard-container td, \n    .dashboard-container th {\n        padding: 12px 15px !important;\n        font-size: 14px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
